var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_right"},[_c('div',{staticClass:"Box"},[_c('div',{staticClass:"testpage"},[_c('iframe',{staticClass:"questionnaire-iframe",attrs:{"src":"https://survey.ideaigc.com/vm/rnYjDw5.aspx","frameborder":"0","allowfullscreen":""}})])])])
}]

export { render, staticRenderFns }